/**
 *
 * @module tokenRequest
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class TokenRequest
 * @desc Information required by TokenClient to exchange a token.
 *
 */
export default class TokenRequest {

    /**
     *
     * @param {String} grantType - The grant type of the token that will be exchanged.
     * @param {Object} tokenData - The parameters that will be added to the token.
     * @param {Number} latitude - The latitude of the device.
     * @param {Number} longitude - The longitude of the device.
     *
     */
    constructor(grantType, tokenData, latitude, longitude) {

        const errorMessage = {
            ctor: 'TokenRequest(grantType, tokenData, latitude, longitude)',
            get grantType() {
                return `${this.ctor} grantType should be a String with length`;
            },
            get tokenData() {
                return `${this.ctor} tokenData should be a plain Object`;
            },
            get latitude() {
                return `${this.ctor} latitude should be a Number`;
            },
            get longitude() {
                return `${this.ctor} latitude should be a Number`;
            }
        };

        nonEmptyString(grantType, errorMessage.grantType, InvalidArgumentException);
        nonEmptyObject(tokenData, errorMessage.tokenData, InvalidArgumentException);

        number(latitude, errorMessage.latitude, InvalidArgumentException);
        number(longitude, errorMessage.longitude, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.grantType = grantType;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.tokenData = tokenData;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.latitude = latitude;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.longitude = longitude;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/tokenRequest.js